'use client';

import { useQueryStates } from 'nuqs';
import { keyMaps, urlKeys } from './utils';

const useDeveloperFilterStore = () => {
  const [developerId, setDeveloperId] = useQueryStates(keyMaps, {
    history: 'push',
    urlKeys,
  });

  return {
    ...developerId,
    setDeveloperId,
  };
};
type DeveloperFilterStore = ReturnType<typeof useDeveloperFilterStore>;

export { type DeveloperFilterStore, useDeveloperFilterStore };
